import React from 'react';

export function IconPen({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M3 21h18v-2H3v2zm16.71-17.71a1 1 0 0 0-1.42 0l-12 12-1 4 4-1 12-12a1 1 0 0 0 0-1.42l-2.58-2.57z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconCheck({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path d="M9 16.2L5.5 12.7l1.4-1.4L9 13.4l8.5-8.5 1.4 1.4L9 16.2z" fill="currentColor" />
    </svg>
  );
}
